import * as React from 'react';
import * as PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';

export const useStyles = makeStyles(
    theme => ({
        day: {
            width: 36,
            height: 36,
            margin: '0 2px',
            fontSize: `14px`,
            color: `#FFFFFF`,
            fontFamily: `"Segoe UI", Verdana, Helvetica, Sans-Serif;`,
            fontWeight: theme.typography.fontWeightMedium,
            padding: 0,
        },
        hidden: {
            opacity: 0,
            pointerEvents: 'none',
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600,
        },
        dayDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint,
        }
    }),
    { name: 'MuiPickersDay' }
);

export interface DayProps {
    /** Day text */
    children: React.ReactNode;
    /** Is today */
    current?: boolean;
    /** Hidden? */
    hidden?: boolean;
}

export const SchedulerDay: React.FC<DayProps> = ({
    children,
    hidden,
    current,
    ...other
}) => {
    const classes = useStyles();

    const className = clsx(classes.day, {
        [classes.hidden]: hidden,
        [classes.current]: current,
    });

    return (
        <IconButton className={className}
            tabIndex={-1}
            {...other}
        >
            <Typography variant="body2" color="inherit">
                {children}
            </Typography>
        </IconButton>
    );
};

SchedulerDay.displayName = 'SchedulerDay';

SchedulerDay.propTypes = {
    current: PropTypes.bool,
    hidden: PropTypes.bool
};

SchedulerDay.defaultProps = {
    hidden: false,
    current: false
};

export default SchedulerDay;